import { render, staticRenderFns } from "./EspeciesTabOcorrencias.vue?vue&type=template&id=0ea18047&"
import script from "./EspeciesTabOcorrencias.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabOcorrencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports